import classNames from "classnames";
import React from "react";
import { intl } from "@fidget/common/i18n/TypedIntl";
import sharedStyles from "../styles.css";
import styles from "./adviserRoleSummary.css";

interface Props {
  role: { name: string };
}
export const AdviserRoleSummary = ({ role }: Props) => {
  return (
    <div className={classNames(sharedStyles.container, styles.container)}>
      <p
        className={classNames(sharedStyles["font-description"], sharedStyles["description-margin"])}
      >
        {intl.formatMessage("settings.advisers.form.role")}
      </p>
      <p className={styles["role-text"]}>{role.name}</p>
    </div>
  );
};
